import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withVariants } from './util';
const Medium = (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" }, { children: [_jsx("path", { fill: "currentColor", d: "M8.62,17.3a.53.53,0,0,1-.39-.16.56.56,0,0,1,0-.79l7.4-7.41-7.4-7.4a.56.56,0,0,1,0-.79A.54.54,0,0,1,9,.75l7.81,7.8a.57.57,0,0,1,0,.79L9,17.14A.54.54,0,0,1,8.62,17.3Z" }, void 0), _jsx("path", { fill: "currentColor", d: "M3.17,17.3a.54.54,0,0,1-.39-.16.56.56,0,0,1,0-.79l7.41-7.41L2.78,1.54A.56.56,0,0,1,3.57.75l7.8,7.8a.56.56,0,0,1,0,.79l-7.8,7.8A.55.55,0,0,1,3.17,17.3Z" }, void 0)] }), void 0));
export const variants = {
    medium: Medium,
    default: Medium,
};
export default withVariants(variants);
